/**
 * This code was generated by Builder.io.
 */
import React, { useState } from "react";
import styles from "./PremiumSelection.module.css";
import StepperSection from "./StepperSection";
import PremiumListSection from "./PremiumListSection";
import SelectOffice from "../SelectOffice/SelectOffice";

const PremiumSelection: React.FC = () => {
  const [showCreatedNew, setShowCreatedNew] = useState(false);
  function handleNextClick(): void {
    setShowCreatedNew(false);
  }

  return (
    <div className={styles.selectPremiumList}>
      <StepperSection />
      <PremiumListSection />
      {showCreatedNew ? (
          <SelectOffice />
        ) : ( 
           <>
             {/* <OfficeList /> */}
             {/* <NavigationButtons onNext={handleNext} /> */}
           </>
        )}

      <button onClick={()=> handleNextClick()} className={styles.nextButton}>
        <span>Next</span>
      </button>
    </div>
  );
};

export default PremiumSelection;
